// ai-sourcing-polling.service.ts
import { Injectable } from '@angular/core';
import { timer, Observable, of } from 'rxjs';
import { switchMap, takeWhile, tap, catchError, endWith } from 'rxjs/operators';
import { AiSourcingService } from './ai-sourcing.service';

@Injectable({
  providedIn: 'root'
})
export class AiSourcingPollingService {

  constructor(private aiSourcingService: AiSourcingService) {}

  /**
   * Starts polling the AI sourcing progress.
   * @param projectNumber Project ID
   * @param type Polling type based on tab (e.g., 'unactioned')
   * @param intervalMs Polling interval in ms
   */
  startPolling(projectNumber: string, type: string = 'unactioned', intervalMs: number = 20000): Observable<any> {
    // TOD0: when type needs to be dynamic, add the logic is based on the currentTab logic-
    // if(this.currentTab === 'review'){
    //   type = 'unactioned'
    // }
    const payload = { projectnumber: projectNumber, type };

    return timer(0, intervalMs).pipe(
      switchMap(() =>
        this.aiSourcingService.getAiSourcingProgress(payload).pipe(
          catchError(err => {
            console.error('Polling error:', err);
            return of({ progress: 0 }); // fallback
          })
        )
      ),
      tap(res => {
        // optional side-effect logging
        console.log('Polling progress:', res.data?.progress);
      }),
      takeWhile((res: any) => (res?.data?.progress ?? 0) < 100, true ),
      endWith({ data: { progress: 100 } }) 
    );
  }
}
